import { render, staticRenderFns } from "./ItemEnquesta.vue?vue&type=template&id=298eaca9&"
import script from "./ItemEnquesta.vue?vue&type=script&lang=js&"
export * from "./ItemEnquesta.vue?vue&type=script&lang=js&"
import style0 from "./ItemEnquesta.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports